import type { RusadaFlightToTechlogContextType } from './types';

/**
 * Path-specific mock data for Rusada → TechLog flight transformation
 * This object matches the exact shape required by the inputZod schema and path-specific context type
 * Uses realistic aviation data with proper airport codes, aircraft registrations, and flight numbers
 */
export const mockData: RusadaFlightToTechlogContextType = {
  rusada: {
    flight: {
      id: 12345,
      flightStatusId: 5,
      flightStatusDescription: 'COMPLETED',
      flightDate: new Date('2024-01-15'),
      departurePlaceId: 1001,
      departurePlaceDescription: 'London Heathrow Airport',
      departureScheduled: new Date('2024-01-15T09:00:00Z'),
      departureEstimate: new Date('2024-01-15T09:00:00Z'),
      departureActual: new Date('2024-01-15T09:15:00Z'),
      departureTakeOff: new Date('2024-01-15T09:20:00Z'),
      arrivalPlaceId: 1002,
      arrivalPlaceDescription: 'Charles de Gaulle Airport',
      arrivalScheduled: new Date('2024-01-15T11:30:00Z'),
      arrivalEstimate: new Date('2024-01-15T11:30:00Z'),
      arrivalLanded: new Date('2024-01-15T11:35:00Z'),
      arrivalActual: new Date('2024-01-15T11:40:00Z'),
      divertedPlaceId: 0,
      divertedPlaceDescription: '',
      divertedReason: '',
      divertedArrivalTime: new Date('2024-01-15T11:40:00Z'),
      customerId: 100,
      customerDescription: 'British Airways',
      flightModelId: 1,
      flightModelDescription: 'Scheduled Service',
      flightLineId: 1,
      flightLineDescription: 'European Routes',
      flightTypeId: 1,
      flightTypeDescription: 'Passenger',
      flightNumberId: 123,
      flightNumberDescription: 'BA123',
      flightRegistrationId: 34,
      flightRegistrationDescription: 'G-VIIA',
      plannedFlightTime: 140,
      calculatedTakeOffTime: new Date('2024-01-15T09:20:00Z'),
      abortCancelCodeId: 0,
      abortCancelCodeDescription: '',
    },
    registration: {
      id: 34,
      assetId: 156,
      registration: 'G-VIIA',
      statusId: 1,
      status: 'ACTIVE',
      serialNo: '29084',
      operator: 'British Airways',
      isLocked: false,
    },
    airports: {
      departure: {
        id: 1001,
        place: 'LHR',
        placeName: 'London Heathrow Airport',
        placeRemarks: 'Major international hub',
        timeZoneId: 1,
        iataCode: 'LHR',
        icaoCode: 'EGLL',
        lHotelIdDefault: 0,
        oHotelIdDefault: 0,
        colour: 0,
        techlogId: 'TL-LHR',
      },
      arrival: {
        id: 1002,
        place: 'CDG',
        placeName: 'Charles de Gaulle Airport',
        placeRemarks: 'Paris main airport',
        timeZoneId: 2,
        iataCode: 'CDG',
        icaoCode: 'LFPG',
        lHotelIdDefault: 0,
        oHotelIdDefault: 0,
        colour: 0,
        techlogId: 'TL-CDG',
      },
      diverted: {
        id: 1003,
        place: 'ORY',
        placeName: 'Orly Airport',
        placeRemarks: 'Paris secondary airport',
        timeZoneId: 2,
        iataCode: 'ORY',
        icaoCode: 'LFPO',
        lHotelIdDefault: 0,
        oHotelIdDefault: 0,
        colour: 0,
      },
      actualArrival: {
        id: 1002,
        place: 'CDG',
        placeName: 'Charles de Gaulle Airport',
        placeRemarks: 'Paris main airport',
        timeZoneId: 2,
        iataCode: 'CDG',
        icaoCode: 'LFPG',
        lHotelIdDefault: 0,
        oHotelIdDefault: 0,
        colour: 0,
        techlogId: 'TL-CDG',
        rusadaId: 1002,
      },
    },
  },
  techlog: {
    aircraft: {
      id: 'TL-AC001',
      registration: 'G-VIIA',
      serialNumber: '29084',
      aircraftTypeId: 'TL-AT001',
      operatorId: 'TL-OP001',
      year: 2020,
      fuelUnit: 'kg',
      oilUnit: 'ml',
      maxFuelValue: 23000,
      monthlyCycles: 120,
      monthlyFlightSeconds: 360000,
      monthlyApuSeconds: 7200,
      maintenanceType: 'hours',
      apuMode: 'installed',
      flightStatus: 'onGround',
      createdAt: '2024-01-01T00:00:00Z',
      updatedAt: '2024-01-15T08:00:00Z',
      aircraftType: {
        id: 'TL-AT001',
        engineType: 'jet',
        engineCount: '2',
        weightCategory: 'heavy',
      },
    },
    airport: {
      departure: {
        id: 1001,
        icaoCode: 'EGLL',
        iataCode: 'LHR',
        latitude: '51.4700',
        longitude: '-0.4543',
      },
      arrival: {
        id: 1002,
        icaoCode: 'LFPG',
        iataCode: 'CDG',
        latitude: '49.0097',
        longitude: '2.5479',
      },
    },
  },
  precomputed: {
    duration: {
      blockTime: 145,
      flightTime: 140,
      groundTime: 25,
    },
    dutyTime: {
      scheduled: 180,
      actual: 185,
    },
  },
};
